export const sanitizeGuaranteedHoursString = (
  guaranteedHoursString: string | null | undefined,
): string => {
  if (!guaranteedHoursString) {
    return 'n/a';
  }

  return guaranteedHoursString.replace(/\s+and\s+paid\s*/gi, ' ').trim();
};
